import { CHANNEL_STYLES, CONV_STATUS_STYLES, STAGE_STYLES } from "@/lib/constants";

export const StatusBadge = ({ status, testid }) => (
  <span className={`inline-flex rounded-full border px-2 py-0.5 text-[11px] font-semibold ${CONV_STATUS_STYLES[status] || ""}`} data-testid={testid}>{status}</span>
);

const base = "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium";

export const StageBadge = ({ stage, testid }) => (
  <span className={`${base} ${STAGE_STYLES[stage] || "bg-slate-50 text-slate-600 border-slate-200"}`} data-testid={testid}>{stage}</span>
);

export const ChannelBadge = ({ channel, testid }) => (
  <span className={`${base} ${CHANNEL_STYLES[channel] || "bg-slate-50 text-slate-600 border-slate-200"}`} data-testid={testid}>{channel}</span>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-display text-2xl font-extrabold tracking-tight text-[#0B2545] sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, icon: Icon, action, children, testid, className = "" }) => (
  <section className={`rounded-2xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_2px_rgba(11,37,69,0.04)] sm:p-6 ${className}`} data-testid={testid}>
    {title && (
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-display text-sm font-bold uppercase tracking-[0.12em] text-slate-500">
          {Icon && <Icon className="h-4 w-4 text-[#1E6FD9]" />} {title}
        </h2>
        {action}
      </div>
    )}
    {children}
  </section>
);
